import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "flex items-center space-x-1" };
import { computed } from 'vue';
import { dedupeInvitationsByEmail } from '@/helpers/invitations';
export default /*#__PURE__*/ _defineComponent({
    __name: 'AvatarList',
    props: {
        invitations: null,
        size: null,
        users: null
    },
    setup(__props) {
        const props = __props;
        /* Displays a list of users. It will display up to MAX_DISPLAYABLE_USERS,
           if there are more users than that, it displays (MAX_DISPLAYABLE_USERS - 1) users and one
           bubble indicating the amount of extra users.  */
        const MAX_DISPLAYABLE_USERS = 4;
        const filteredInvitations = computed(() => {
            return dedupeInvitationsByEmail(props.invitations || []);
        });
        const extraUsers = computed(() => {
            return props.users.length - MAX_DISPLAYABLE_USERS;
        });
        const displayableUsers = computed(() => {
            if (extraUsers.value > 0) {
                return props.users.slice(0, MAX_DISPLAYABLE_USERS);
            }
            else {
                return props.users;
            }
        });
        const displayableInvitations = computed(() => {
            if (displayableUsers.value.length < MAX_DISPLAYABLE_USERS) {
                return filteredInvitations.value.slice(0, MAX_DISPLAYABLE_USERS - displayableUsers.value.length);
            }
            return [];
        });
        const extraNames = computed(() => {
            const names = props.users.slice(MAX_DISPLAYABLE_USERS).map(({ name }) => name);
            const emails = filteredInvitations.value
                .slice(MAX_DISPLAYABLE_USERS - displayableUsers.value.length)
                .map(({ email }) => email);
            return [...names, ...emails].join('<br/>');
        });
        return (_ctx, _cache) => {
            const _component_Avatar = _resolveComponent("Avatar");
            const _directive_tooltip = _resolveDirective("tooltip");
            return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(displayableUsers), (user) => {
                    return (_openBlock(), _createElementBlock("li", {
                        key: user.id
                    }, [
                        _withDirectives(_createVNode(_component_Avatar, {
                            class: "cursor-default",
                            size: __props.size || 'sm',
                            "show-tooltip": false,
                            user: user
                        }, null, 8, ["size", "user"]), [
                            [
                                _directive_tooltip,
                                user.name,
                                void 0,
                                { bottom: true }
                            ]
                        ])
                    ]));
                }), 128)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(displayableInvitations), (invite) => {
                    return (_openBlock(), _createElementBlock("li", {
                        key: invite.id
                    }, [
                        _withDirectives(_createVNode(_component_Avatar, {
                            class: "cursor-default",
                            size: __props.size || 'sm',
                            "show-tooltip": false
                        }, null, 8, ["size"]), [
                            [
                                _directive_tooltip,
                                invite.email,
                                void 0,
                                { bottom: true }
                            ]
                        ])
                    ]));
                }), 128)),
                (_unref(extraUsers) + _unref(filteredInvitations).length > 0)
                    ? _withDirectives((_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(["flex items-center justify-center text-gray-400 bg-gray-100 rounded-full cursor-default", __props.size === 'sm' ? 'w-6 h-6 text-xs' : 'w-10 h-10'])
                    }, [
                        _createTextVNode(" +" + _toDisplayString(_unref(extraUsers) + _unref(filteredInvitations).length), 1)
                    ], 2)), [
                        [
                            _directive_tooltip,
                            { content: _unref(extraNames), html: true },
                            void 0,
                            { bottom: true }
                        ]
                    ])
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
